import { isServer } from './isServer';

export const createScrollHandler = (target?: string | Element) => {
  if (isServer) {
    return {};
  }
  let currentTarget: Element | Window = window;
  let isAutoScrolling = false;

  if (typeof target === 'string') {
    currentTarget = document.querySelector(target as string);
  }

  const unsub = (handler: EventListenerOrEventListenerObject) => {
    currentTarget.removeEventListener('scroll', handler);
  };

  const sub = (handler: (event: Event, isAuto?: boolean) => void) => {
    currentTarget.addEventListener('scroll', (e) => {
      handler(e, isAutoScrolling);
    });

    return () => {
      unsub(handler);
    };
  };

  const scrollTo = (opt?: ScrollToOptions) => {
    isAutoScrolling = true;
    (currentTarget as HTMLElement)?.scrollTo(opt);

    const scrollEndHandler = () => {
      isAutoScrolling = false;
      currentTarget.removeEventListener('scrollend', scrollEndHandler);
    };

    currentTarget.addEventListener('scrollend', scrollEndHandler);
  };

  return {
    unsub,
    sub,
    scrollTo,
  };
};

export const documentScrollHandler = createScrollHandler();
